import {
  BundleIcon,
  CalendarIcon,
  GraduationHat02Icon,
  Tag01Icon,
  Users01Icon,
} from '@systemeio/icons'
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum'
import React, { ReactNode } from 'react'

export const resourceTypeIcons: Partial<Record<DigitalResourcesTypeEnum, ReactNode>> = {
  [DigitalResourcesTypeEnum.membership_course]: <GraduationHat02Icon />,
  [DigitalResourcesTypeEnum.membership_course_bundle]: <BundleIcon />,
  [DigitalResourcesTypeEnum.systemeio_tag]: <Tag01Icon />,
  [DigitalResourcesTypeEnum.community_access]: <Users01Icon />,
  [DigitalResourcesTypeEnum.booking_event]: <CalendarIcon />,
}
